import { Box, Flex, Heading } from '@radix-ui/themes';
import { AddPitchIcon } from 'components/common/custom-icon/shorthands';
import { ErrorBoundary } from 'components/common/error-boundary';
import { CommonTableCheckedMenu } from 'components/common/table/checked-menu';
import { GameDataContext } from 'contexts/game-data.context';
import { CheckedContext } from 'contexts/layout/checked.context';
import { t } from 'i18next';
import { IMenuAction } from 'interfaces/i-menus';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { IMlbPlayer } from 'lib_ts/interfaces/mlb-stats-api/i-player';
import { useContext, useMemo } from 'react';

interface IProps {
  pitchers: IMlbPlayer[];
}

// only necessary for pitchers view because we don't add avgs for hitters
export const GameDataPitchersFooter = (props: IProps) => {
  const { tally, getChecked } = useContext(CheckedContext);
  const { openImportPitchersDialog } = useContext(GameDataContext);

  const actions = useMemo<IMenuAction[]>(() => {
    const items = props.pitchers.filter((m) => getChecked(m._id));
    if (items.length === 0) {
      return [];
    }

    const output: IMenuAction[] = [
      {
        prefixIcon: <AddPitchIcon />,
        label: 'common.add-repertoires-to-pitch-lists',
        onClick: () => openImportPitchersDialog(items),
      },
    ];

    return output;
  }, [tally.key]);

  return (
    <ErrorBoundary identifier="GameDataFooter">
      {actions.length > 0 && (
        <Flex gap={RADIX.FLEX.GAP.SM}>
          <Heading size={RADIX.HEADING.SIZE.MD} mb="1">
            {tally.checked}&nbsp;
            {t('common.selected').toLowerCase()}
          </Heading>
          <Box ml="1" className="valign-center">
            <CommonTableCheckedMenu actions={actions} />
          </Box>
        </Flex>
      )}
    </ErrorBoundary>
  );
};
